"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaffAddOnDetailsMap = exports.StaffAddOnDetailPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StaffAddOnDetailsMap = exports.StaffAddOnDetailsMap = {
  'routineCare': {
    limitKey: 'routineCareLimit',
    breakdownLimitKey: 'routineCareLimitBreakDown'
  },
  'dental': {
    limitKey: 'dentalCareLimit',
    breakdownLimitKey: 'dentalCareLimitBreakDown'
  },
  'alternativeCare': {
    limitKey: 'alternativeCareLimit',
    breakdownLimitKey: 'alternativeCareLimitBreakDown'
  }
};
var StaffAddOnDetailPropTypes = exports.StaffAddOnDetailPropTypes = {
  limitKey: _propTypes["default"].string,
  breakdownLimitKey: _propTypes["default"].string
};